export enum MatchingConditionOperator {
    AND = 'and',
    OR = 'or',
    NONE = '',
}

export enum ActionTypes {
    IS = "is",
    IS_NOT = "is_not",
    CONTAINS = "contains",
    DOES_NOT_CONTAIN = "does_not_contain",
}